/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ApplyIdActionsNames {
  static ChangeHeight = (): string => '[ApplyId] ChangeHeight';
  static ChangeHeightSuccess = (): string => '[ApplyId] ChangeHeight Success';

  static ValidateSelection = (): string => '[ApplyId] ValidateSelection';
  static ValidateSelectionSuccess = (): string => '[ApplyId] ValidateSelection Success';

  static ApplyIdClick = (): string => '[ApplyId] ApplyIdClick';
  static ApplyIdClickSuccess = (): string => '[ApplyId] ApplyIdClick Success';

  static ClosePopupAction = (): string => '[ApplyId] ClosePopupAction';
  static ClosePopupActionSuccess = (): string => '[ApplyId] ClosePopupAction Success';
}
